import React from 'react'

function Experience() {
  return (
    <div class="container" id='experience' >
	
	<main class="row">


		<section class="col">
			
			<header class="title">
				<h2>EXPERIENCE</h2>
			</header>

			<div class="contents">
				
				<div class="box">
					<h4>11th August -11th September 2023</h4>
					<h3>Software Developer Intern at <b>Maclogs Private Limited</b></h3>
					<ul>
					<li>- Developed a B2B client data platform using React.JS and Java Spring Boot, facilitating data collection and client tracking.</li>
					<li>- Implemented Test-Driven Development (TDD) in Spring Boot for form validation during new account creation, ensuring data integrity through Postman testing.</li>
					</ul>
					
				</div>

			</div>
		</section>
		<section class="col">
			
			<header class="title">
				<h2>EDUCATION</h2>
			</header>

			<div class="contents">

				<div class="box">
					<h4>2020 - 2024</h4>
					<h3>JSS Academy Of Technical Education, Bangalore</h3>
					<p>BE in Computer Science And Engineering (2024)</p>
					<p><b>Score - 8.49 % </b>(till 6th semester)</p>
	
				</div>

				<div class="box">
					<h4>2019 - 2020</h4>
					<h3>Kendriya Vidyalaya No. 3 Vadodara Gujarat</h3>
					<p>Higher Secondary Certificate (HSC) with PCM + CS</p>
					<p><b>Score - 87.4 %</b></p>
				</div>	

				<div class="box">
					<h4>2017 - 2018</h4>
					<h3>Kendriya Vidyalaya No. 3 Vadodara, Gujarat</h3>
					<p>Senior Secondary Certificate (SSC)</p>
					<p><b>Score - 84.6 %</b></p>
				</div>


			</div>
		</section>
	</main>
</div>
  )
}

export default Experience